"use client";
import * as React from "react";
const SvgSentimentNeutralFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M4 6a1.2 1.2 0 1 1 2.4 0A1.2 1.2 0 0 1 4 6m6.4 4.8H5.6V9.6h4.8zm.4-3.6a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4" }));
export {
  SvgSentimentNeutralFilled as default
};
